import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06499a6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=06499a6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06499a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06499a6a')) {
      api.createRecord('06499a6a', component.options)
    } else {
      api.reload('06499a6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=06499a6a&scoped=true", function () {
      api.rerender('06499a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oa/components/RelatedBusinessCell/index.vue"
export default component.exports